import { CreateTaskRequest } from 'compliance-api';
import { RRule } from 'rrule';

export const sanitizeTaskReminders = <T extends CreateTaskRequest>(reportData: T): T => {
  if (!reportData.due_remainders || !reportData.due_remainders.length) return reportData;

  const validaReminders = reportData.due_remainders.filter(({ frequency }) => {
    const {
      options: { freq },
    } = RRule.fromString(frequency);
    return !!freq;
  });

  return { ...reportData, due_remainders: validaReminders };
};
